import Keycloak from 'keycloak-js'
import {
  KEY_CLOAK_CLIENT_ID,
  KEY_CLOAK_REALM,
  KEY_CLOAK_URL,
} from 'shared/constants/defaultENV'

export const keycloak = Keycloak({
  url: KEY_CLOAK_URL,
  realm: KEY_CLOAK_REALM,
  clientId: KEY_CLOAK_CLIENT_ID,
})
